/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'prop-types'
], (React, PropTypes) => {

	return class Separator extends React.Component {

		static propTypes = {
			name: PropTypes.string.isRequired
		};

		render() {
			return (
				<div className={`carbonPropertyRow separator capp_${this.props.name}`}/>
			);
		}
	};

});